import React from 'react'
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { profileStore } from 'src/hooks/profile';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const GuestPopupActionButton = (props) => {
    const { data, SetStatus } = props;
    const [{  }, { get_profile_account_information }, {  }] = profileStore();
    const { translation:t } = System;
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const onSubmit = async() => {
        if (data?.shipadd) {
            __set("SET_INVOICE_ADDRESS")
            const res = await data?.addressId(data?.shipadd)
            __remove("SET_INVOICE_ADDRESS")
            if (res?.isSuccessFull) {
                await get_profile_account_information()
                SetStatus(false)
                system_alert_indicator({
                    name: 'profile',
                    message: '<b>'+t('shippingAddress')+'</b>'+' '+t('hasBeenDeleted') + ".",
                    type: "success"
                  })
            }
        } else {
            window.location.href = System.getLoginPageUrl()
        }
    }

    return (
        <>
            <div className="avnet-modal modal-530">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{data.title}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />

                        <div className='mb-3 text-center mt-4 mb-5'>
                            {data.body}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                            {data.closeButton}
                            </button>
                            <button className="bs5 btn btn-primary btn-sm w145" onClick={() => onSubmit()}>
                            {__check(['SET_INVOICE_ADDRESS']).status ? 
                                <i className="fa fa-spinner fa-spin" /> : 
                                data.yesButton}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GuestPopupActionButton